'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AUTH_FAIL = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.loadSuccess = loadSuccess;
exports.loadFail = loadFail;
exports.login = login;
exports.loginSuccess = loginSuccess;
exports.loginFail = loginFail;
exports.logout = logout;
exports.logoutSuccess = logoutSuccess;
exports.logoutFail = logoutFail;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'auth/LOAD';
var LOAD_SUCCESS = 'auth/LOAD_SUCCESS';
var LOAD_FAIL = 'auth/LOAD_FAIL';
var LOGIN = 'auth/LOGIN';
var LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
var LOGIN_FAIL = 'auth/LOGIN_FAIL';
var LOGOUT = 'auth/LOGOUT';
var LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS';
var LOGOUT_FAIL = 'auth/LOGOUT_FAIL';
var AUTH_FAIL = exports.AUTH_FAIL = 'SESSION_ERROR';

var initialState = {
  authorized: false,
  loaded: false,
  username: '',
  totalPoint: 0,
  errors: []
};

// TODO: should be simplified
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loaded: false,
        authorized: false
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        username: action.auth.username,
        totalPoint: action.auth.totalPoint,
        loaded: true,
        authorized: true // This timing, server side should be published session cookie.
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loaded: true,
        errors: action.err.errors,
        authorized: false
      });
    case LOGIN:
      return (0, _extends3.default)({}, state, {
        authorized: false
      });
    case LOGIN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        authorized: true // This timing, server side should be published session cookie.
      });
    case LOGIN_FAIL:
      return (0, _extends3.default)({}, state, {
        errors: action.err.errors,
        authorized: false
      });
    case LOGOUT:
      return (0, _extends3.default)({}, initialState);
    case LOGOUT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        authorized: false
      });
    case LOGOUT_FAIL:
      return (0, _extends3.default)({}, state, {
        errors: action.err.errors,
        authorized: false
      });
    case AUTH_FAIL:
      return (0, _extends3.default)({}, state, {
        errors: action.err.errors,
        authorized: false
      });
    default:
      return state;
  }
}

function isLoaded(state) {
  return state && state.auth && state.auth.loaded;
}

function load() {
  return {
    type: LOAD
  };
}

function loadSuccess(_ref) {
  var username = _ref.username,
      totalPoint = _ref.totalPoint;

  return {
    type: LOAD_SUCCESS,
    auth: { username: username, totalPoint: totalPoint }
  };
}

function loadFail(err) {
  return {
    type: LOAD_FAIL,
    err: err
  };
}

// TODO: use this function when we have login API
function login() {
  return {
    type: LOGIN
  };
}

// TODO: use this function when we have login API
function loginSuccess() {
  return {
    type: LOGIN_SUCCESS
  };
}

// TODO: use this function when we have login API
function loginFail(err) {
  return {
    type: LOGIN_FAIL,
    err: err
  };
}

function logout() {
  return {
    type: LOGOUT
  };
}

// TODO: use this function when we have logout API
function logoutSuccess() {
  return {
    type: LOGOUT_SUCCESS
  };
}

// TODO: use this function when we have logout API
function logoutFail(err) {
  return {
    type: LOGOUT_FAIL,
    err: err
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/auth.js
// module id = 583
// module chunks = 0